import React from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";

import { leadershipData } from "utils/consts";



const OurTeam = () => {
  return (
    <>
      <Typography
        fontFamily="Inter"
        fontSize="32px"
        fontWeight="300"
        textTransform="uppercase"
        borderBottom="1px solid #D9D9D9"
        paddingBottom="24px"
        marginTop="100px"
      >
        <span style={{ color: "#FFE000" }}>/ </span>our team
      </Typography>

      <Grid container spacing={3} marginTop="30px">
        {leadershipData.map((member, index) => (
          <Grid item lg={3} md={4} sm={6} xs={12} key={index}>
            <Card
              sx={{ maxWidth: "379px", height: "536" }}
              style={{ backgroundColor: "#FFFFFF", boxShadow: "none" }}
            >
              <CardMedia
                component="img"
                image={member.image}
                alt={member.name}
              />
              <CardContent>
                <Typography fontFamily="Inter" fontSize="22px" fontWeight="400">
                  {member.name}
                </Typography>
                <Typography
                  fontFamily="Inter"
                  fontSize="16px"
                  fontWeight="400"
                  color="#999696"
                >
                  {member.role}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </>
  );
};

export default OurTeam;
